<template>
  <div class="not_data_wrap">
    <img class="data_image" src="../../assets/images/icon_not_data.png">
    <span class="data_info">{{ desc }}</span>
  </div>
</template>

<script>
export default {
  props: {
    desc: {
      type: String,
      default: () => {
        return '暂无数据'
      }
    }
  },
  data() {
    return {

    }
  },
  methods: {

  }
}
</script>

<style lang='less' scoped>
.not_data_wrap {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .data_image {
    width: 240px;
    height: 240px;
    margin-bottom: 20px;
  }

  .data_info {
    display: inline-block;
    height: 30px;
    line-height: 30px;
    font-size: 20px;
    color: #bebebe;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/space/space.vue